import { Modal } from "flowbite-react";
import { IDevolutionDeposit } from "@/types/devolution-deposit";
import FormCreateReturnofdeposit from "../forms/FormCreateDevolutionDeposit";
import { createReturnOfDeposit } from "@/common/services/devolution-deposit.api";

type Props = {
  data?: IDevolutionDeposit;
  onClose: () => void;
  onSave: (formData: Partial<IDevolutionDeposit>) => void;
  onNewItemClick?: () => void;
  closeModal?: () => void
};

export default function ModalCreateReturnofdeposit({ data, onClose, onSave }: Props) {

  const handleSave = async (formData: Partial<IDevolutionDeposit>) => {
    try {
      const response = await createReturnOfDeposit(formData);
      if (response.ok) {
        if (onSave) onSave(formData);
      } else {
        console.error("Erro ao salvar:", response);
      }
    } catch (err) {
      console.error("Erro inesperado:", err);
    }
  };

  return (
    <Modal className='relative text-black' show={true} onClose={onClose}>

      <Modal.Header className='text-black dark:text-black'>
        <h2 className="text-black">{data ? 'Editar Devolução de Depósito' : 'Nova Devolução de Depósito'}</h2>
      </Modal.Header>

      <Modal.Body className='text-black dark:text-black'>
        <FormCreateReturnofdeposit onSave={handleSave} onCancel={onClose} />
      </Modal.Body>
    </Modal>
  );
}
